// Общие тексты оболочки и навигации.
export const ru = {
  common: {
    appName: 'GenRaskladka',
    save: 'Сохранить',
    saved: 'Сохранено',
    cancel: 'Отмена',
    close: 'Закрыть',
    create: 'Создать',
    add: 'Добавить',
    edit: 'Изменить',
    delete: 'Удалить',
    remove: 'Убрать',
    confirm: 'Подтвердить',
    back: 'Назад',
    retry: 'Повторить',
    combobox: {
      loading: 'Загрузка…',
      empty: 'Ничего не найдено',
      failed: 'Не удалось загрузить варианты',
      clear: 'Очистить',
    },
    loading: 'Загрузка…',
    search: 'Поиск',
    all: 'Все',
    showMore: 'Показать ещё',
    yes: 'Да',
    no: 'Нет',
    none: '—',
    open: 'Открыть',
    moveUp: 'Выше',
    moveDown: 'Ниже',
    copy: 'Копировать',
    copied: 'Скопировано',
    download: 'Скачать',
    notFoundTitle: 'Страница не найдена',
    notFoundText: 'Такой страницы нет или у вас нет к ней доступа.',
    toHome: 'На главную',
    loadFailed: 'Не удалось загрузить данные',
  },
  realtime: {
    offline: 'Нет связи с сервером.',
    offlineText: 'Изменения не приходят сами — переподключаюсь.',
    reconnect: 'Переподключить',
  },
  nav: {
    main: 'Основная навигация',
    openMenu: 'Открыть меню',
    closeMenu: 'Закрыть меню',
    blog: 'Блог',
    switchBlog: 'Сменить блог',
    content: 'Контент',
    posts: 'Посты',
    media: 'Медиатека',
    references: 'Справочники',
    plan: 'План',
    queue: 'Очередь',
    calendar: 'Календарь',
    publishing: 'Публикация',
    due: 'К публикации',
    settings: 'Настройки блога',
    myBlogs: 'Мои блоги',
    adminGroup: 'Администрирование платформы',
    admin: 'Пользователи',
    adminOverview: 'Обзор системы',
    adminBlogs: 'Все блоги',
    adminOnline: 'Онлайн',
    adminSettings: 'Настройки платформы',
    adminApiKeys: 'Ключи API',
    adminPlans: 'Тарифы',
    adminTasks: 'Фоновые задачи',
    adminBackups: 'Резервные копии',
    profile: 'Профиль',
    logout: 'Выйти',
    dueCount: 'Ожидают публикации: {n}',
  },
};

export const en: typeof ru = {
  common: {
    appName: 'GenRaskladka',
    save: 'Save',
    saved: 'Saved',
    cancel: 'Cancel',
    close: 'Close',
    create: 'Create',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    remove: 'Remove',
    confirm: 'Confirm',
    back: 'Back',
    retry: 'Retry',
    combobox: {
      loading: 'Loading…',
      empty: 'Nothing found',
      failed: 'Could not load options',
      clear: 'Clear',
    },
    loading: 'Loading…',
    search: 'Search',
    all: 'All',
    showMore: 'Show more',
    yes: 'Yes',
    no: 'No',
    none: '—',
    open: 'Open',
    moveUp: 'Move up',
    moveDown: 'Move down',
    copy: 'Copy',
    copied: 'Copied',
    download: 'Download',
    notFoundTitle: 'Page not found',
    notFoundText: "This page doesn't exist or you don't have access to it.",
    toHome: 'Go home',
    loadFailed: "Couldn't load data",
  },
  realtime: {
    offline: 'No connection to the server.',
    offlineText: 'Updates are not arriving — reconnecting.',
    reconnect: 'Reconnect',
  },
  nav: {
    main: 'Main navigation',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    blog: 'Blog',
    switchBlog: 'Switch blog',
    content: 'Content',
    posts: 'Posts',
    media: 'Media library',
    references: 'References',
    plan: 'Plan',
    queue: 'Queue',
    calendar: 'Calendar',
    publishing: 'Publishing',
    due: 'Ready to publish',
    settings: 'Blog settings',
    myBlogs: 'My blogs',
    adminGroup: 'Platform administration',
    admin: 'Users',
    adminOverview: 'System overview',
    adminBlogs: 'All blogs',
    adminOnline: 'Online',
    adminSettings: 'Platform settings',
    adminApiKeys: 'API keys',
    adminPlans: 'Plans',
    adminTasks: 'Background tasks',
    adminBackups: 'Backups',
    profile: 'Profile',
    logout: 'Sign out',
    dueCount: 'Waiting to publish: {n}',
  },
};
